import { profile_types } from "../../../../core/components/common/variables/static_variables";
import { useRBACStore } from "../../../RBACPlugin";

const REACT_APP_API_ENDPOINT = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT;
const ORGANIZATION_SEVICE_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1/organization";
const BUSINESS_DRIVER_SEVICE_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1/drivers";
const ORGANIZATION_USER_SERVICE_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1/users/organization";
const VEHICLE_USER_SERVICE_BASE_URL = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/vehicle";
const GATEPASS_SERVICE_BASE_URL = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/gatepass/organization";
const SUBSCRIPTION_SERVICE_BASE_URL = REACT_APP_API_ENDPOINT +"/api/v1/subscription/org";
const ORGANIZATION_DASHBOARD_SERVICE_BASE_URL = REACT_APP_API_ENDPOINT + "/api/v1/dashboard";
const ORGANIZATION_ASSET_DASHBOARD_SERVICE_BASE_URL = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/dashboard";

const getPrefixRoute = () => {
    const { userType } = useRBACStore.getState();
    let prefixRoute = `${REACT_APP_API_ENDPOINT}/api/v1`;

    if (userType === profile_types.PORT_EMPLOYEE) {
        prefixRoute += '/';
    }

    if (userType === profile_types.BUSINESS) {
        prefixRoute += '/org';
    }

    return prefixRoute;
};


export default {

    //sample only
    LIST_VEHICLE:                       getPrefixRoute() + "/list",

    // org
    LIST_ORG:                           ORGANIZATION_SEVICE_BASE_URL + "/list",
    CREATE_ORG:                         ORGANIZATION_SEVICE_BASE_URL + "/create-new",
    VIEW_ORG:                           ORGANIZATION_SEVICE_BASE_URL + "/view",
    UPDATE_ORG:                         ORGANIZATION_SEVICE_BASE_URL + "/update",
    FILTER_LIST_ORG:                    ORGANIZATION_SEVICE_BASE_URL + "/list/filter",


    // Business Driver:
    BUSINESS_DRIVER_LIST:               BUSINESS_DRIVER_SEVICE_BASE_URL + "/list",
    CREATE_BUSINESS_DRIVER:             BUSINESS_DRIVER_SEVICE_BASE_URL + "/create",
    BUSINESS_VIEW_DRIVER_LIST:          BUSINESS_DRIVER_SEVICE_BASE_URL + "/view",
    UPDATE_BUSINESS_DRIVER_STATUS:      BUSINESS_DRIVER_SEVICE_BASE_URL + "/update/status",

    // Org User
    LIST_ORGANIZATION_USER:             ORGANIZATION_USER_SERVICE_BASE_URL + "/list",

    // Vehicle
    LIST_ORG_VEHICLE:                   VEHICLE_USER_SERVICE_BASE_URL + "/list",

    // Gatepass
    LIST_ORG_GATEPASS:                  GATEPASS_SERVICE_BASE_URL + "/list",

    // Subscription
    VIEW_ORG_SUBSCRIPTION:              SUBSCRIPTION_SERVICE_BASE_URL + "/view/active",

    // EID Dashboard
    COUNT_USERS:                        ORGANIZATION_DASHBOARD_SERVICE_BASE_URL + "/users/count",
    COUNT_USERS_ROLE:                   ORGANIZATION_DASHBOARD_SERVICE_BASE_URL + "/users/count/roles",

    // ASSET Dashboard
    COUNT_GATEPASSES:           ORGANIZATION_ASSET_DASHBOARD_SERVICE_BASE_URL + "/counter/gatepass",
    COUNT_VEHICLES:   ORGANIZATION_ASSET_DASHBOARD_SERVICE_BASE_URL + "/counter/vehicle",
    COUNT_BOOKINGS:   ORGANIZATION_ASSET_DASHBOARD_SERVICE_BASE_URL + "/counter/booking", 
    
}
